import React from 'react';
import { observer } from 'mobx-react-lite';
import { candiesByIndex } from '../../../../../enums';
import { candyDataStore } from '../../../../../store';

export const Result = observer(() => {
  const { multiplierData, currentWheelType } = candyDataStore;

  return multiplierData && !currentWheelType ? (
    <div className='small-circle-img-wrapper'>
      <img src={candiesByIndex[multiplierData.multiplierCandy]} alt='candy' />
      <p className='sm-circle-item-coef'>x{multiplierData.multiplierOdd}</p>

      <div className='wheel-win-animation-block '>
        <div className='sm-c-an-big-shadow ' />
      </div>
    </div>
  ) : null;
});
